<script lang="ts">
  import { screens, playerTruth } from '../store';
  import type { DieCreation, Die as DieType } from './models/die.type';
  import { createDie } from './models/die.type';
  import DiceTray from './dice-tray/dice-tray.svelte';
  import Icon from './icon/icon.svelte';
  import { send, receive } from '../animation';
  import Frame from './components/frame.svelte';
  import Chrome from './components/chrome.svelte';
  import DieElement from './dice-tray/die.svelte';
  import { alert } from './modals/modals';

  let playerDie: Array<DieType> = $state(
    $playerTruth.dice.map((die: DieCreation, index: number) => {
      return createDie(die, index, 'p' + index);
    }),
  );

  $playerTruth.healthMax += 2;
  $playerTruth.healthCurrent += 2;
  $playerTruth.level += 1;

  let selectedDie: DieType[] = $state([]);
  let upgradedDie: DieType[] = $state([]);
  let index: number;

  const clickDie = (die: DieType) => {
    index = playerDie.indexOf(die);
    // selectedDie.push(playerDie[index]);
    if (selectedDie.length) {
      playerDie.push(selectedDie[0]);
    }
    selectedDie = [die];
    playerDie.splice(index, 1);

    let level = selectedDie[0].level + 1;

    if (level >= 3) {
      upgradedDie[0] = createDie(
        {
          type: selectedDie[0].type,
          level: 0,
          material: selectedDie[0].material,
        },
        100,
        'new' + Math.random(),
      );
      upgradedDie[1] = createDie(
        {
          type: selectedDie[0].type,
          level: 0,
          material: selectedDie[0].material,
        },
        100,
        'new' + Math.random(),
      );
    } else {
      upgradedDie = [
        createDie(
          {
            type: selectedDie[0].type,
            level: level,
            material: selectedDie[0].material,
          },
          100,
          'new' + Math.random(),
        ),
      ];
    }
  };

  function confirm() {
    if (!upgradedDie[0]) {
      alert({
        title: 'No Die Selected',
        text: 'Please select a die to upgrade',
      });
      return;
    }
    $playerTruth.dice[index].level = upgradedDie[0].level;

    if (upgradedDie[1]) {
      $playerTruth.dice.splice(index, 0, {
        type: upgradedDie[1].type,
        level: 0,
        material: upgradedDie[1].material,
      });
    }

    screens.pop();
  }

  function cancel() {
    screens.pop();
  }
</script>

<div class="background"></div>

<Frame>
  <div class="container">
    <h1>Choose a die to upgrade</h1>

    <div class="upgrade">
      <div>
        <h2>
          {#if selectedDie[0]}
            {selectedDie[0].label}
          {/if}
        </h2>
        <div class="die">
          <div class="slot"></div>
          {#each selectedDie as die, index (die.id)}
            <div class="die-holder" in:receive={{ key: die.id }} out:send={{ key: die.id }}>
              <DieElement {die} hover={true} die3D={false} />
            </div>
          {/each}
        </div>
      </div>

      <div class="arrow">
        <Icon name="nextarrow" width="100%" height="100%" />
      </div>

      <div class="transform-die">
        <div>
          <h2>
            {#if upgradedDie[0]}
              {upgradedDie[0].label}
            {/if}
          </h2>
          <div class="die">
            <div class="slot"></div>
            {#each upgradedDie as die, index (die.id)}
              <div class="die-holder" in:receive={{ key: die.id }} out:send={{ key: die.id }}>
                <DieElement {die} hover={true} die3D={false} />
              </div>
            {/each}
          </div>
        </div>

        {#if upgradedDie[1]}
          <div>
            <h2>
              {#if upgradedDie[0]}
                {upgradedDie[0].label}
              {/if}
            </h2>
            <div class="die">
              <div class="slot"></div>
              {#each upgradedDie as die, index (die.id)}
                <div class="die-holder" in:receive={{ key: die.id }} out:send={{ key: die.id }}>
                  <DieElement {die} hover={true} die3D={false} />
                </div>
              {/each}
            </div>
          </div>
        {/if}
      </div>
    </div>

    <div class="dice-tray">
      <DiceTray clickEvent={clickDie} dice={playerDie} clazz="horizontal" />
    </div>

    <div class="button-container">
      <Chrome click={cancel} edge="circle" chroming="obsidian">
        <div class="button">Cancel</div>
      </Chrome>
      <Chrome click={confirm} edge="circle" chroming="gold">
        <div class="button">Confirm Upgrade</div>
      </Chrome>
    </div>
  </div>
</Frame>

<style lang="less">
  .background {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    filter: blur(5px);
    z-index: 0;
    box-shadow: inset 0 0 40px 10px rgba(0, 0, 0, 0.5);
    background-image: url('../assets/backgrounds/levelup.webp');
  }

  .button-container {
    display: flex;
    justify-content: end;
    width: 100%;
    grid-gap: 20px;
    margin-top: 20px;

    .button {
      font-size: 28px;
      padding: 6px 12px;
      color: #ffffd5;
    }
  }

  .container {
    display: flex;
    flex-direction: column;
    grid-gap: 50px;
    --background-colour: #121212;
    --background-colour-light: lighten(#121212, 10%);
    --background-colour-dark: darken(#121212, 5%);

    .upgrade {
      display: grid;
      grid-template-columns: 1fr 75px 1fr;

      h2 {
        text-align: center;
        margin-bottom: 10px;
      }

      .arrow {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .die-holder {
        position: absolute;
      }
      .die {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      .slot {
        border-radius: 4px;
        height: calc(var(--dice-size) + 20px);
        width: calc(var(--dice-size) + 20px);
        background: var(--background-colour-light);
        box-shadow: inset var(--background-colour) 5px 5px 10px;
        outline: var(--background-colour) 2px solid;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .transform-die {
        display: flex;
        justify-content: center;
        grid-gap: 20px;
      }
    }

    .dice-tray {
      display: flex;
      justify-content: center;
      background-color: var(--background-colour-light);
      margin: auto;
      padding: 10px;
      border-radius: 8px;
      border: var(--background-colour) 2px solid;
      // box-shadow: inset 0 0 50px 0px var(--background-colour);
    }
  }
</style>
